import { getSizedImageUrl, imageSize } from '@/lib/images'
import { formatMoney } from '@/lib/currency'

export function createProductCard(product, newDif, isClerkProduct = false) {
    const imgLazy = product.images[0]
        ? getSizedImageUrl(product.images[0].replace('.' + imageSize(product.images[0]), ''), '1x')
        : ''
    const img = product.images[0]
        ? getSizedImageUrl(product.images[0].replace('.' + imageSize(product.images[0]), ''), '1024x')
        : ''

    const isNew = checkIfNew(product)
    const savePercent = getSavePercent(product)

    function checkIfNew(product) {
        const productDate = new Date(product.published_at.slice(0, 10))
        const nowDate = new Date()

        const timeDif = nowDate.getTime() - productDate.getTime()
        const dayDif = timeDif / (1000 * 3600 * 24)

        if (dayDif <= newDif) {
            return true
        } else {
            return false
        }
    }

    function getSavePercent(product) {
        let percent = 0

        const saleVariant = product.variants.find(
            (variant) => variant.compare_at_price && parseInt(variant.compare_at_price) > parseInt(variant.price)
        )
        if (saleVariant) {
            const price = parseInt(saleVariant.price)
            const comparePrice = parseInt(saleVariant.compare_at_price)
            percent = Math.floor(100 - (price / comparePrice) * 100)
        }

        return percent
    }

    let availableVariants = product.variants.filter((variant) => variant.available === true) // Get available variants
    availableVariants.filter((value, index, self) => {
        return self.findIndex((v) => v.option1.name === value.option1.name) === index
    })
    let availableSizes = availableVariants.map((v) => v.option1)
    let sizes = availableSizes.slice(0, 5)
    let sizesString = sizes.join(', ')
    if (availableSizes.length > 5) sizesString = sizesString + ' ...'

    return `<a href="/products/${product.handle}" class="grid__item" data-clerk-product-id="${product.id}">
                <div class="product-card">
                    <figure class="product-card__image">
                        <img src="${imgLazy}" data-src="${img}" class="lazyload js-img">
                        ${(() => {
                            if (savePercent > 0) {
                                return `<div class="product-card__badge"><svg class="icon icon--scissors" viewBox="0 0 397.8 260.7">    <path d="M393.1,203.5c-13.8-5.9-27.3-12.4-41-18.7c-18.8-8.6-37.7-17.2-56.5-25.9c-14.8-6.8-29.6-13.8-44.4-20.6    c-5.5-2.5-10.9-5-17-7.8c0.1-0.1,0.2-0.1,0.4-0.2c-0.1-0.1-0.2-0.1-0.4-0.2c6.1-2.8,11.5-5.3,17-7.8c14.8-6.9,29.6-13.8,44.4-20.6    c18.8-8.7,37.7-17.3,56.5-25.9c13.6-6.3,27.1-12.8,41-18.7c3.5-1.5,5.4-2.9,4.5-6.5c-1.2-4.7-2.7-9.1-7.3-12.2    c-7.6-5-16-5.7-24.2-4.5c-20.8,3-40.3,10.3-59.3,19.2C291.9,60,277,66.8,262.1,73.5c-24,10.7-48,21.3-72,32.1    c-3.5,1.6-6.2,1.4-9.5-0.2c-12.6-5.8-25.4-11.2-37.9-17.1c-5-2.3-10.7-4.4-14.1-8.4c-7.7-8.9-12-19.7-14.2-31.3    C111,30.2,101.5,15.4,84.7,7.1C63.2-3.5,42-2.6,22.2,12.3C3.4,26.4-2.1,45.8,0.7,67.8c1.9,15.7,10.8,28,23.6,37.1    c13.5,9.6,28.7,11.6,44.6,8.9c13.2-2.3,26.3-6.2,39.4,0.8c9.9,5.3,20.1,10,30.8,15.3c-0.3,0.1-0.6,0.3-0.9,0.4    c0.3,0.1,0.6,0.3,0.9,0.4c-10.7,5.3-20.9,10-30.8,15.3c-13.1,7-26.2,3.1-39.4,0.8c-16-2.8-31.2-0.7-44.6,8.9    c-12.8,9.1-21.6,21.5-23.6,37.1c-2.7,22,2.7,41.4,21.5,55.5c19.8,14.9,41,15.8,62.5,5.2c16.9-8.3,26.3-23.1,29.7-41.6    c2.1-11.6,6.5-22.4,14.2-31.3c3.4-3.9,9.2-6.1,14.1-8.4c12.6-5.9,25.4-11.3,37.9-17.1c3.3-1.5,6-1.7,9.5-0.2    c23.9,10.8,48,21.4,72,32.1c14.9,6.7,29.8,13.4,44.6,20.3c19,8.9,38.5,16.2,59.3,19.2c8.2,1.2,16.6,0.5,24.2-4.5    c4.6-3.1,6.1-7.5,7.3-12.2C398.5,206.4,396.6,205,393.1,203.5z M90.7,60.1c-1,14.1-15.2,31.6-34.7,30.9    c-15.9-0.6-33.6-15.9-31.7-33.6c-1.8-15.8,15.7-34.1,34.9-33C73.1,25.1,92.2,40.1,90.7,60.1z M59.2,236.3    c-19.2,1.1-36.7-17.2-34.9-33c-1.9-17.7,15.8-33,31.7-33.6c19.5-0.7,33.7,16.8,34.7,30.9C92.2,220.6,73.1,235.6,59.2,236.3z"/></svg>
                                        ${savePercent}%</div>`
                            } else if (isNew) {
                                return `<div class="product-card__badge">New</div>`
                            } else {
                                return ''
                            }
                        })()}
                    </figure>
                    <p class="product-card__vendor">${product.vendor}</p>
                    <p class="product-card__title">${product.title}</p>
                    <div class="product-card__prices">
                        ${(() => {
                            const comparePrice = parseFloat(product.variants[0].compare_at_price)
                            const nowPrice = parseFloat(product.variants[0].price)
                            if (comparePrice && comparePrice > nowPrice) {
                                return `
                                            <div class="price--old">${formatMoney(comparePrice)}</div>
                                            <div class="price">${formatMoney(nowPrice)}</div>
                                            `
                            } else {
                                return `
                                            <div class="price">${formatMoney(nowPrice)}</div>
                                            `
                            }
                        })()}
                    </div>
                    <div class="product-card__sizes">
                        ${sizesString}
                    </div>
                </div>
            </a>
            `
}
